import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import SingleFormLayout from '../../../../../../../../../baseComponents/Layout/SingleFormLayout'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { useTypeIdNumber } from '../../../../../../../../../utils/hooks/useTypeIdNumber'
import { getActiveLangs, getAllClientManagerEmployees, getConfigParam } from '../../../../../../../../../utils/reducers/getters'
import { EmployeesPayload } from '../../../../../../../../../utils/reducers/company/employees'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { Fragment, useMemo } from 'react'
import { addDictionaryExtraLine, TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { useNavigate } from 'react-router'
import { ButtonRedSecondary } from '../../../../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import ModalChangeActiveCustomer from '../../../../../../../../../specificComponents/Customers/ModalChangeActiveCustomerCustomer'
import locations from '../../../../../../../../../utils/globals/locations'


type MainCustomerB2BProfileProps = ComponentWithPermissions & ReduxMainCustomerB2BProfile & {
    basicData: CustomerModelType | null
    getData: () => Promise<void>
    extraProps?: TwinDictionary
}

const MainCustomerB2BProfile: React.FC<MainCustomerB2BProfileProps> = ({ basicData, userPermissions, getData, extraProps, employees }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const { typesIdNumber } = useTypeIdNumber()
    const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false
    const myEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getConfigParam('showOnlyClientManagerEmployees') === 'on' ? getAllClientManagerEmployees() || {} : employees || {}))), [employees])

    const fields: FormRender<CustomerModelType> = [
        {
            cols: 2,
            title: t('generalInformation', 'Información general'),
            elements: [

                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'fiscal_name',
                    label: t('fiscalName', 'Nombre fiscal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'type_id_number',
                    label: t('typeIdNumber', 'Tipo de documento identificación'),
                    component: 'CustomSelect',
                    items: typesIdNumber,
                    value: basicData?.type_id_number,
                },
                {
                    name: 'id_number',
                    label: t('id_number', 'DNI'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'code',
                    label: t('customerCode', 'Código de Cliente'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
                {
                    name: 'customer_card',
                    label: t('customerCard', 'Tarjeta de cliente'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'responsable_name',
                    label: t('responsableName', 'Nombre del responsable'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'ResponsibleEmployeeId',
                    label: t('ourManager', 'Nuestro gestor'),
                    component: 'CustomSelectWithSearchBar',
                    items: myEmployees || {},
                    fieldName: 'fullname_short',
                    sortItems: true
                }
            ]
        },
        {
            cols: 2,
            title: t('contactInformation', 'Datos de contacto'),
            elements: [
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email',
                },
                {
                    name: 'web',
                    label: t('web', 'Página web'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                },
                {
                    name: 'CustomerOriginId',
                    label: t('origin', 'Origen'),
                    component: 'CustomSelectWithSearchBar',
                    items: extraProps?.dictCustomerOrigins || {},
                },
                {
                    name: 'newsletter',
                    label: t('newsletter', 'Newsletter'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        },
    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)
    const extraButtons = [
        <ButtonRedSecondary className='regular14' onClick={() => setOpenModal({ type: 'delete', allRowData: {} })}><TwinTrans transKey='delete'>Eliminar</TwinTrans></ButtonRedSecondary>
    ]

    return (
        <Fragment>
            <SingleFormLayout action='/api/app/customer/updateCustomer' onSubmit={getData} sections={parsedFields} userPermissions={userPermissions} extraButtonsLeft={extraButtons} />
            {openModal?.type === 'delete' ? <ModalChangeActiveCustomer {...{ setOpened: () => setOpenModal(null) }} allRowData={basicData || {}} onSubmit={() => navigate(locations.customer + '/' + (showAllCustomersTogether ? 'allCustomers' : 'customersB2B'))} /> : null}
        </Fragment>
    )
}

const mainCustomerB2BProfileDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

export type ReduxMainCustomerB2BProfile = ConnectedProps<typeof mainCustomerB2BProfileConnect>
const mapMainCustomerB2BProfileTypesConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const mainCustomerB2BProfileConnect = connect(mapMainCustomerB2BProfileTypesConnector, mainCustomerB2BProfileDispatch)

const mainCustomerB2BProfileConnectLoading = withLoading(MainCustomerB2BProfile, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])

const ModalCreateMainCustomerB2BProfileConnect = mainCustomerB2BProfileConnect(mainCustomerB2BProfileConnectLoading)

export default ModalCreateMainCustomerB2BProfileConnect